import { h, Component } from 'preact';
import Store from 'store/store';
import { slotMachineIcons } from 'helpers/downWorldData.js';
import { pause } from 'helpers';
import { getRiggedSlotMachine } from 'utils/querySimulation';

import s from 'components/bolt/downWorld/slotMachineStrips/slotMachineStrips.sss';

export default class SlotMachineStrips extends Component {
	constructor(props) {
		super(props);
		this.currentIndexes = [0, 0, 0];
		this.stripWidths = [0, 0, 0];

		this.state = {
			backgroundPositionY0: 0,
			backgroundPositionY1: 0,
			backgroundPositionY2: 0
		};

		this.getStripWidths = this.getStripWidths.bind(this);
		this.onSlotMachineLoaded = this.onSlotMachineLoaded.bind(this);
		this.onSlotMachinePull = this.onSlotMachinePull.bind(this);

		this.homeEntEnabled = Store.get()?.appData?.options?.enableHomeEnt;
		this.slotMachineIcons = slotMachineIcons.filter(s => !(s === 'super-bell' && !this.homeEntEnabled));	
	}

	componentDidMount() {
		Store.on('SLOT_MACHINE_LOADED', this.onSlotMachineLoaded);
		Store.on('SLOT_MACHINE_PULL', this.onSlotMachinePull);
		window.addEventListener('resize', this.getStripWidths);
		this.riggedResult = getRiggedSlotMachine();
	}

	componentWillUnmount() {
		Store.off('SLOT_MACHINE_LOADED', this.onSlotMachineLoaded);
		Store.off('SLOT_MACHINE_PULL', this.onSlotMachinePull);
		window.removeEventListener('resize', this.getStripWidths);
	}

	getStripWidths() {
		const stripWidths = this.stripWidths.map((width, i) => {
			const strip = this[`$strip${i}`];
			return strip ? (strip.getBoundingClientRect()?.width) : 0;
		});
		this.stripWidths = stripWidths;
	}

	setUpStrips() {
		const newIndexes = this.currentIndexes.map(() => {
			const newIndex = Math.floor(Math.random() * this.slotMachineIcons.length);
			return newIndex;
		});
		this.currentIndexes = newIndexes;
		this.currentIndexes.forEach((iconIndex, stripIndex) => {
			this.fastSetStripBackgroundPositionY(stripIndex, iconIndex);
		});
	}

	fastSetStripBackgroundPositionY(stripIndex, iconIndex) {
		const strip = this[`$strip${stripIndex}`];
		if (strip) {
			strip.style.transition = 'none';
			this.setState({
				[`backgroundPositionY${stripIndex}`]: iconIndex * this.stripWidths[stripIndex]
			});
		}
	}

	onSlotMachineLoaded() {
		this.getStripWidths();
		this.setUpStrips();
	}

	getIconNamesFromIndexes(indexes) {
		return indexes.map(index => this.slotMachineIcons[index]);
	}

	getIndexFromIconName(name) {
		return this.slotMachineIcons.findIndex(iconName => iconName === name);
	}

	getRiggedDelta(currentIndex, desiredIndex) {
		let currentPosition = currentIndex < 2 ? currentIndex + this.slotMachineIcons.length : currentIndex;
		let desiredPosition = desiredIndex < 2 ? desiredIndex + this.slotMachineIcons.length : desiredIndex;
		if (desiredPosition >= currentPosition) {
			return desiredPosition - currentPosition;
		}
		return (desiredPosition + this.slotMachineIcons.length) - currentPosition;
	}

	async onSlotMachinePull() {
		// player always wins
		let forcedIndex = Math.floor(Math.random() * this.slotMachineIcons.length);
		await Promise.all(this.currentIndexes.map(async (iconIndex, stripIndex) => {
			return await this.rollStrip(iconIndex, stripIndex, forcedIndex);
		}));
		const finalIcons = this.getIconNamesFromIndexes(this.currentIndexes);
		this.checkWin(finalIcons);
	}

	checkWin(finalIcons) {
		const isWin = finalIcons.every(icon => icon === finalIcons[0]);
		if (!isWin) {
			Store.emit('SLOT_MACHINE_ANIM_COMPLETE');
		} else {
			Store.emit('SLOT_MACHINE_WIN', finalIcons[0]);
			Store.emit('CUSTOM_EVENT', {
				action: 'slot-machine-click',
				category: 'minus-world',
				label: finalIcons[0]
			});
		}
	}

	async rollStrip(iconIndex, stripIndex, forcedIndex) {
		if (this.stripWidths[stripIndex] === 0) {
			this.getStripWidths();
		}
		await pause(300 * stripIndex);

		let desiredDelta = forcedIndex > -1 ? this.getRiggedDelta(iconIndex, forcedIndex) : Math.floor(Math.random() * this.slotMachineIcons.length);
		if (this.riggedResult) {
			const desiredIconIndex = this.getIndexFromIconName(this.riggedResult);
			if (desiredIconIndex > -1) {
				desiredDelta = this.getRiggedDelta(iconIndex, desiredIconIndex);
			}
		}
		const newDelta = desiredDelta + (5 * this.slotMachineIcons.length); // roll through the whole strip 5 times before landing on the new icon
		const distanceToTranslate = newDelta * this.stripWidths[stripIndex];
		const strip = this[`$strip${stripIndex}`];
		const currentBgPosY = this.state[`backgroundPositionY${stripIndex}`];
		const newBgPosY = currentBgPosY + distanceToTranslate;
		const animationTime = 3500;
		strip.style.transition = `background-position ${animationTime}ms cubic-bezier(.51,.15,.23,1.09)`;
		this.setState({
			[`backgroundPositionY${stripIndex}`]: newBgPosY
		});
		await pause(animationTime);
		const newIndex = (iconIndex + newDelta) % this.slotMachineIcons.length;
		this.currentIndexes[stripIndex] = newIndex;
		this.fastSetStripBackgroundPositionY(stripIndex, newIndex);
	}


	render({ imageRoot }) {
		return (
			<div class={s.container}>
				{new Array(3).fill('x').map((el, i) => (
					<div
						class={s.strip}
						key={`slot-machine-strip-${i}`}
						ref={($ref) => this[`$strip${i}`] = $ref}
						style={{
							backgroundImage: `url(${imageRoot}/down/slot-machine-icons/strip/${this.homeEntEnabled ? 'full-strip-final-homeEnt.webp' : 'full-strip-final.webp'})`,
							backgroundPositionY: `${this.state[`backgroundPositionY${i}`]}px`
						}}
					/>
				))}
			</div>
		);
	}
}